import React from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { toast } from "react-toastify";
import moment from "moment";
import { savebooking } from "./../../services/wms/grabconcept";
const Confirmcall = ({
  isOpen,
  header,
  onCancel,
  listcall,
  error,
  size = "sl",
  reload,
}) => {
  let Daterec = moment(new Date(), "YYYY-MM-DD").format("YYYY-MM-DD HH:mm");
  const handlesavecall = (even1, even2) => {
    doSubmit(even1, even2);
  };
  const doSubmit = async (id, status) => {
    try {
      const doc = {
        statusid: status,
        id: id,
        DatecheckIn: Daterec,
      };
      const { data: result } = await savebooking(doc);

      if (result === true) {
        toast.success("บันทึกเสร็จเรียบร้อย");
        onCancel(false);
        reload(id);
        const urlGoBack = "/CardQueueCall/";
      } else if (result === false) {
        toast.error("ไม่พบ");
        onCancel(false);
      }
    } catch (err) {
      toast.error("Error");
    }
  };
  return (
    <div>
      <Modal
        isOpen={isOpen}
        toggle={onCancel}
        size={size}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <ModalHeader>
          {header}
          <p className="text-danger">ยืนยันการเรียกคิว</p>

          <p className="font-weight-normal"></p>
        </ModalHeader>
        <ModalBody>{listcall && listcall.length > 0 && listcall[1]}</ModalBody>
        {error && <div className="col-md-12 alert alert-danger"> {error}</div>}

        <ModalFooter>
          {listcall && <div className="col-lg-4  col-sm-6 col-xs-12"> </div>}

          {listcall && (
            <Button
              color="primary"
              onClick={() => handlesavecall(listcall[0], listcall[2])}
            >
              บันทึก
            </Button>
          )}
          <Button color="secondary" onClick={onCancel}>
            ยกเลิก
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default Confirmcall;
